import React , { useContext } from 'react' ;
import CartStyle from './Cart.module.css';
import Modal from '../UI/Modal';
import CartContext from '../../store/cart-contex';

import CartItems from './CartItem' ;


function Cart(props) {

  const cartCtx = useContext(CartContext) ;

  const totalAmount = `$${cartCtx.totalAmount.toFixed(2)}` ;
  const hasItems = cartCtx.items.length > 0 ;

  function cartItemRemoveHandler(id) {
    cartCtx.removeItem(id)
  } ;

  function cartItemAddHandler(item) {
    cartCtx.addItem({...item , amount: 1})
  } ;
 
  const cartItems = <ul className={CartStyle['cart-items']}>{cartCtx.items.map(item => 
    <CartItems 
      key={item.id} 
      name={item.name} 
      amount={item.amount} 
      price={item.price} 
      onRemove={cartItemRemoveHandler.bind(null , item.id)} 
      onAdd={cartItemAddHandler.bind(null , item)} />
  )}</ul> ;

  return (
    <Modal onHideCartHandler={props.onHideCartHandler}>
      {cartItems}

      <div className={CartStyle.total}>
        <span>Total Amount</span>
        <span>{totalAmount}</span>
      </div>

    <div className={CartStyle.actions}>
        <button className={CartStyle['button--alt']}  onClick={props.onHideCartHandler}>Close</button>
        {hasItems && <button className={CartStyle.button}>Order</button>}
    </div>

    </Modal>
  )
}

export default Cart;